module.exports = __webpack_public_path__ + "static/media/step4.12909674.png";